<template>
  <material-card
  color="primary"
  full-width
  cardClass="mb-0">
  <template #header>
    <v-row no-gutters align="center" class="mb-n2">
      <v-col>
        <span class="headline font-weight-regular" v-text="product.name" style="word-break: break-word"/>
      </v-col>
      <v-col cols="auto">
        <BaseDialogActions hideFullscreen hideRefresh @close="$emit('close')">
          <template #left>
            <Icon
            :disabled="!userAssignedClaim(UserClaims.GlobalAdmin)"
            icon="mdi-pencil"
            iconColor="tertiary"
            :small="false"
            :tooltipText="$t('editItem', { item: $t('product') })"
            @icon-clicked="$emit('edit', product)"/>
          </template>
        </BaseDialogActions>
      </v-col>
    </v-row>
  </template>
    <v-container class="pt-6" style="max-height: 80vh;">
      <v-row>
        <v-col cols="12" :md="colsMd">
          <DetailCard>
            <v-row v-for="row in content" :key="row[0]" dense>
              <v-col>
                <span>{{ $t(row[0]) }}:</span>
              </v-col>
              <v-col cols="12" sm="4" xl="auto">
                <Icon v-if="row[1] === true" icon="mdi-check-circle" :tooltipText="$t('yes')" margin=""/>
                <Icon v-else-if="row[1] === false" icon="mdi-close-circle" :tooltipText="$t('no')" margin=""/>
                <span v-else>{{ row[1] }}</span>
              </v-col>
            </v-row>
          </DetailCard>
        </v-col>
        <v-col cols="12" md="6" v-if="product.productSpecies.length > 0">
          <DetailCard :title="$t('species')">
            <v-data-table
            :items="product.productSpecies"
            :headers="speciesHeaders"
            :hide-default-footer="product.productSpecies.length < 6"
            :items-per-page="5"
            :footer-props="{ 'disable-items-per-page': true, 'items-per-page-options': [5] }"
            dense
            class="small-headers"/>
          </DetailCard>
        </v-col>
        <v-col cols="12" md="6" v-if="product.productGrades.length > 0">
          <DetailCard :title="$t('grades')">
            <v-data-table
            :items="product.productGrades"
            :headers="headers"
            :hide-default-footer="product.productGrades.length < 6"
            :items-per-page="5"
            :footer-props="{ 'disable-items-per-page': true, 'items-per-page-options': [5] }"
            dense
            class="small-headers"/>
          </DetailCard>
        </v-col>
        <v-col cols="12" md="6" v-if="product.productEndUseSorts.length > 0">
          <DetailCard :title="$t('endUseSorts')">
            <v-data-table
            :items="product.productEndUseSorts"
            :headers="headers"
            :hide-default-footer="product.productEndUseSorts.length < 6"
            :items-per-page="5"
            :footer-props="{ 'disable-items-per-page': true, 'items-per-page-options': [5] }"
            dense
            class="small-headers"/>
          </DetailCard>
        </v-col>
      </v-row>
    </v-container>
  </material-card>
</template>

<script>
import { userAssignedClaim } from '@/utils/ClaimUtility'
import { UserClaims, TimberType, WoodType } from '@/utils/Enumerations'

export default {
  name: 'ProductDetail',

  components: {
    Icon: () => import('@/components/helper/Icon.vue'),
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue'),
    DetailCard: () => import('@/components/core/DetailCard.vue')
  },

  props: {
    product: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    UserClaims
  }),

  computed: {
    content () {
      const getValue = (key) => {
        const val = this.product[key]
        switch (key) {
          case 'woodType': return WoodType.fromInt(val)
          case 'timberType': return TimberType.fromInt(val)
          default: return val
        }
      }

      return [
        'code',
        'timberType',
        'woodType',
        'conversionRateW2V',
        'collectPieceInfo'
      ].map(c => [
        c,
        getValue(c)
      ])
    },

    headers () {
      return [
        {
          text: this.$t('name'),
          value: 'name'
        },
        {
          text: this.$t('code'),
          value: 'code'
        }
      ]
    },

    speciesHeaders () {
      return [
        {
          text: this.$t('name'),
          value: 'commonName'
        },
        {
          text: this.$t('code'),
          value: 'code'
        },
        {
          text: this.$t('taxonomicName'),
          value: 'speciesName'
        }
      ]
    },

    colsMd () {
      const p = this.product
      return p.productSpecies?.length + p.productGrades?.length + p.productEndUseSorts?.length > 0 ? 6 : 12
    }
  },

  methods: {
    userAssignedClaim
  }
}

</script>
